<ngb-alert [type]="'danger'" [hidden]="!show" [dismissible]="false">
  Your account is scheduled for cancellation on {{ deactivatesAt }} UTC. Please
  visit <a class="alert-link" href="/account/edit">your account settings page</a>
  to reverse the cancellation before your account is canceled.
</ngb-alert>
